export const T = {
  en_GB: {
    title: "Adjustment Questions",
    description:
      "Up to 3 questions that adjust the risk score. Each answer sets a signed delta per initial score. The client's answers are summed into the score adjustment.",
    matrixHint:
      "Add at least one time horizon and one risk level (with matrix scores) before configuring adjustment questions.",
    addQuestion: "Add Question",
    enabled: "Enabled",
    questionLabel: "Question",
    questionPlaceholder: "e.g., If your investments fall 20%, what would you do?",
    answers: "Answers",
    answerPlaceholder: "e.g., Buy more",
    addAnswer: "Add Answer",
    matrix: "Delta matrix (by initial score)",
    matrixColHint:
      "Columns = initial score. Enter a signed delta per cell (between -100 and 100, up to one decimal place, e.g. 0.5; negatives allowed).",
    answerColumn: "Answer",
    error: "Error",
    failedToSave: "Failed to save adjustment questions",
    invalidDelta:
      "Deltas must be numbers between -100 and 100 with at most one decimal place (e.g. 0.5).",
    remove: "Remove",
    save: "Save",
    discardChanges: "Discard",
    questionLabelRequired: (n: string) => `Question ${n}: the question text is required.`,
    answerLabelRequired: (n: string, m: string) => `Question ${n}: answer ${m} is missing a label.`,
  },
  nb_NO: {
    title: "Justeringsspørsmål",
    description:
      "Inntil 3 spørsmål som justerer risikoscoren. Hvert svar setter et fortegnsatt delta per utgangsscore. Klientens svar summeres til justeringen.",
    matrixHint:
      "Legg til minst én tidshorisont og ett risikonivå (med matriseverdier) før du konfigurerer justeringsspørsmål.",
    addQuestion: "Legg til spørsmål",
    enabled: "Aktivert",
    questionLabel: "Spørsmål",
    questionPlaceholder: "f.eks. Hvis investeringene faller 20 %, hva ville du gjort?",
    answers: "Svar",
    answerPlaceholder: "f.eks. Kjøpe mer",
    addAnswer: "Legg til svar",
    matrix: "Delta-matrise (etter utgangsscore)",
    matrixColHint:
      "Kolonner = utgangsscore. Skriv et fortegnsatt delta per celle (mellom -100 og 100, maks én desimal, f.eks. 0.5; negative tillatt).",
    answerColumn: "Svar",
    error: "Feil",
    failedToSave: "Kunne ikke lagre justeringsspørsmål",
    invalidDelta: "Delta må være et tall mellom -100 og 100 med maks én desimal (f.eks. 0.5).",
    remove: "Fjern",
    save: "Lagre",
    discardChanges: "Forkast",
    questionLabelRequired: (n: string) => `Spørsmål ${n}: spørsmålsteksten er påkrevd.`,
    answerLabelRequired: (n: string, m: string) => `Spørsmål ${n}: svar ${m} mangler tekst.`,
  },
} as const;
